import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_BLOCK_FAILURE,
  ADD_BLOCK_REQUEST,
  ADD_BLOCK_SUCCESS,
  DELETE_BLOCK_FAILURE,
  DELETE_BLOCK_REQUEST,
  DELETE_BLOCK_SUCCESS,
  FETCH_BLOCK_FAILURE,
  FETCH_BLOCK_REQUEST,
  FETCH_BLOCK_SUCCESS,
  FETCH_LIST_ALL_BLOCK_FAILURE,
  FETCH_LIST_ALL_BLOCK_REQUEST,
  FETCH_LIST_ALL_BLOCK_SUCCESS,
  FETCH_LIST_BLOCK_FAILURE,
  FETCH_LIST_BLOCK_REQUEST,
  FETCH_LIST_BLOCK_SUCCESS,
  RESET_CURRENT_BLOCK,
  UPDATE_BLOCK_FAILURE,
  UPDATE_BLOCK_REQUEST,
  UPDATE_BLOCK_SUCCESS,
  FETCH_COMMON_BLOCK_REQUEST,
  FETCH_COMMON_BLOCK_SUCCESS,
  FETCH_COMMON_BLOCK_FAILURE,
} from "./blockType";

const initialState = {
  Blocks: [],
  currentBlock: null,
  fetchBlocks: { ...defaultStatus },
  fetchAllBlocks: { ...defaultStatus },
  fetchBlock: { ...defaultStatus },
  addBlock: { ...defaultStatus },
  updateBlock: { ...defaultStatus },
  deleteBlock: { ...defaultStatus },
  fetchCommonBlocks: { ...defaultStatus },
  commonBlocks: [],
  formMode: null,
};

const BlockReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_LIST_ALL_BLOCK_REQUEST:
      return {
        ...state,
        fetchAllBlocks: { ...state.fetchAllBlocks, inProgress: true },
      };
    case FETCH_LIST_ALL_BLOCK_SUCCESS:
      return {
        ...state,
        fetchAllBlocks: {
          ...state.fetchAllBlocks,
          success: true,
          inProgress: false,
          Blocks: payload?.blocks,
        },
      };
    case FETCH_LIST_ALL_BLOCK_FAILURE:
      return {
        ...state,
        fetchAllBlocks: {
          ...state.fetchAllBlocks,
          error: true,
          errorMessage: payload.error,
        },
      };

    case FETCH_LIST_BLOCK_REQUEST:
      return {
        ...state,
        fetchBlocks: { ...state.fetchBlocks, inProgress: true },
      };
    case FETCH_LIST_BLOCK_SUCCESS:
      return {
        ...state,
        fetchBlocks: {
          ...state.fetchBlocks,
          success: true,
          inProgress: false,
          Blocks: payload?.blocks,
        },
      };
    case FETCH_LIST_BLOCK_FAILURE:
      return {
        ...state,
        fetchBlocks: {
          ...state.fetchBlocks,
          error: true,
          errorMessage: payload.error,
        },
      };

    case FETCH_BLOCK_REQUEST:
      return {
        ...state,
        fetchBlock: { ...state.fetchBlock, inProgress: true },
      };
    case FETCH_BLOCK_SUCCESS:
      return {
        ...state,
        fetchBlock: { ...state.fetchBlock, success: true, inProgress: false },
        currentBlock: payload.Block,
      };
    case FETCH_BLOCK_FAILURE:
      return {
        ...state,
        fetchBlock: {
          ...state.fetchBlock,
          error: true,
          errorMessage: payload.error,
        },
      };

    case ADD_BLOCK_REQUEST:
      return {
        ...state,
        addBlock: { ...state.addBlock, inProgress: true },
      };
    case ADD_BLOCK_SUCCESS:
      return {
        ...state,
        addBlock: { ...state.addBlock, success: true, inProgress: false },
        Blocks: [...state.Blocks, payload.Block],
        currentBlock: payload.Block,
      };
    case ADD_BLOCK_FAILURE:
      return {
        ...state,
        addBlock: {
          ...state.addBlock,
          error: true,
          errorMessage: payload.error,
        },
      };

    case UPDATE_BLOCK_REQUEST:
      return {
        ...state,
        updateBlock: { ...state.updateBlock, inProgress: true },
      };
    case UPDATE_BLOCK_SUCCESS: {
      const updatedBlock = payload.Block;
      return {
        ...state,
        updateBlock: { ...state.updateBlock, success: true, inProgress: false },
        Blocks: state.Blocks.map((Block) =>
          Block.id === updatedBlock.id ? updatedBlock : Block
        ),
        currentBlock: updatedBlock,
      };
    }
    case UPDATE_BLOCK_FAILURE:
      return {
        ...state,
        updateBlock: {
          ...state.updateBlock,
          error: true,
          errorMessage: payload.error,
        },
      };

    case DELETE_BLOCK_REQUEST:
      return {
        ...state,
        deleteBlock: { ...state.deleteBlock, inProgress: true },
      };
    case DELETE_BLOCK_SUCCESS:
      return {
        ...state,
        deleteBlock: { ...state.deleteBlock, success: true, inProgress: false },
        Blocks: state.Blocks.filter((Block) => Block.id !== payload.BlockId),
        currentBlock:
          state.currentBlock?.id === payload.BlockId
            ? null
            : state.currentBlock,
      };
    case DELETE_BLOCK_FAILURE:
      return {
        ...state,
        deleteBlock: {
          ...state.deleteBlock,
          error: true,
          errorMessage: payload.error,
        },
      };

    case RESET_CURRENT_BLOCK:
      return {
        ...state,
        currentBlock: null,
      };

    case FETCH_COMMON_BLOCK_REQUEST:
      return {
        ...state,
        fetchCommonBlocks: { ...state.fetchCommonBlocks, inProgress: true },
      };
    case FETCH_COMMON_BLOCK_SUCCESS:
      return {
        ...state,
        fetchCommonBlocks: {
          ...state.fetchCommonBlocks,
          success: true,
          inProgress: false,
        },
        commonBlocks: payload.blocks,
      };
    case FETCH_COMMON_BLOCK_FAILURE:
      return {
        ...state,
        fetchCommonBlocks: {
          ...state.fetchCommonBlocks,
          error: true,
          errorMessage: payload.error,
        },
      };

    default:
      return state;
  }
};

export default BlockReducer;
